document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
    const button = document.querySelector(".contact-us-page .btn-submit");
    const colorElement = document.querySelector(".getcolor");

    if (button && colorElement) {
      const getBgColor = colorElement.getAttribute("data-bg-color");
      const getTextColor = colorElement.getAttribute("data-text-color");
      const getHoverColor = colorElement.getAttribute("data-hover-color");
      const getHoverTextColor = colorElement.getAttribute("data-hover-text-color");

      button.style.backgroundColor = getBgColor;
      button.style.color = getTextColor;

      button.addEventListener("mouseenter", function () {
        button.style.backgroundColor = getHoverColor;
        button.style.color = getHoverTextColor;
      });

      button.addEventListener("mouseleave", function () {
        button.style.backgroundColor = getBgColor;
        button.style.color = getTextColor;
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});